var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankSeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 80,
    viewBox: "0 0 260 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.856 59.9593H113.179V20H114.856V59.9593Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.478 30.1864C109.478 30.1864 105.134 25.8907 97.7142 25.8907C90.479 25.8907 86.5226 30.3032 86.5226 34.603C86.5226 37.7227 88.1877 41.1969 94.0986 42.7657C95.866 43.2349 97.4877 43.6119 99.2711 44.0264L99.2771 44.0278C99.6901 44.1238 100.112 44.2219 100.546 44.3235C102.594 44.8016 103.499 45.6808 103.265 46.7839C102.976 48.148 100.729 48.6714 98.3295 48.6714C96.2351 48.6714 93.7292 48.2208 90.1259 45.0447L85 48.9228C86.4587 50.6867 91.3401 54.4603 98.5074 54.4603C105.672 54.4603 111.023 51.3035 111.023 45.2068C111.023 40.7875 108.042 38.8794 103.685 37.6211C101.47 36.9836 99.8424 36.5414 98.2773 36.1162C97.7717 35.9788 97.2725 35.8432 96.7621 35.7033C94.9285 35.2019 93.865 34.3007 94.1217 33.1386C94.3879 31.9448 96.1061 31.4654 97.7563 31.4654C99.3834 31.4654 102.336 31.8569 104.626 33.8488L109.478 30.1864Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.401 26.3181V32.5645H126.368V36.9151H136.308V42.9458H126.368V47.35H140.798V53.65H118.776V26.3181H140.401Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.635 59.9593H145.313V20H143.635V59.9593Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.225 26.3182V53.6487H166.593C171.238 53.6487 175.005 50.8202 175.005 46.2869C175.005 42.7509 172.715 40.4018 169.504 39.3729C169.504 39.3729 169.374 39.3385 169.196 39.3303C169.374 39.3138 169.507 39.2781 169.507 39.2781C171.343 38.5417 173.38 36.5814 173.38 33.246C173.38 29.0162 169.678 26.3182 165.113 26.3182H149.225ZM166.653 45.0835C166.653 46.5012 165.59 47.5754 164.276 47.5754L156.856 47.5768V42.5929H164.276C165.59 42.5929 166.653 43.6672 166.653 45.0835ZM156.856 36.7985V32.0014H162.922C164.32 32.0014 165.451 33.1182 165.451 34.4013C165.451 35.6844 164.32 36.7985 162.922 36.7985H156.856Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSeb);
export default __webpack_public_path__ + "static/media/bank-seb.43325bbc967e6873e4d71839d1408ff0.svg";
export { ForwardRef as ReactComponent };